export default "__VITE_ASSET__CS60bdhf__"